import React, {useEffect, useState, useRef} from "react";
import MapComponent from "./components/Map";
import {ensure_slug} from './utils';
import { UserInfoProvider } from "./contexts/UserInfoContext";
import axios from 'axios';

const MapModule = ({types_to_exclude}) => {
	const [municipalities, setMunicipalities] = useState();
	const [loaded, setLoaded] = useState(false);
	const [mapData, setMapData] = useState();

	const fetchMap = () => {
		let queryParams = '';
		municipalities.map(municipality => {
			queryParams += `&municipalities[]=${municipality.id}`;
		});
		queryParams.substring(1);

		axios.get(`/wp-json/ir/v1/municipalities/mapdata/?${queryParams}`).then(res => {
			setMapData(res.data);
			setLoaded(true);
		}).catch(error => {
			console.log(error)
		});
	}

	const getMunicipalitiesAndFetch = () => {
		axios.get('/wp-json/ir/v1/municipalities').then(res => {
			const municipalitiesArray = new Array();
			res.data.map(municipality => {
				const filter = new Object();
				filter.id = municipality.id;
				filter.label = municipality.name;
				filter.value = ensure_slug(municipality.name);
				filter.type = 'municipality';
				municipalitiesArray.push(filter);
			})
			setMunicipalities(municipalitiesArray);
			// fetchMap();
		}).catch(error => {
			console.log(error);
		})
	}

	useEffect(() => {
		if (!loaded && !municipalities) {
			getMunicipalitiesAndFetch();
		} else if (!loaded) {
			fetchMap();
		}
	}, [loaded, municipalities])

	return (
	<UserInfoProvider>
		{loaded ? (
			<MapComponent map={mapData} filters={municipalities} exclude_types={types_to_exclude} />
		) : (
			<>
				<div className="smart-map__sidebar" data-loading="true">Laster inn kartdata</div>
				<div className="smart-map__map"  data-loading="true"></div>
			</>
		)}
	</UserInfoProvider>
	)
}

export default MapModule;
